import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

export default function Empathy() {
  const [exercises, setExercises] = useState([]);

  useEffect(() => {
    api.get("/empathy/exercises").then(({ data }) => setExercises(data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="page-empathy">
      <div className="text-xs tracking-[0.25em] uppercase text-mindora-red mb-4">
        <span className="editorial-rule" />Empathy toolkit
      </div>
      <h1 className="font-serif text-5xl lg:text-6xl text-mindora-ink leading-tight max-w-3xl">
        Skills that turn into<br /><em className="italic text-mindora-red">better conversations.</em>
      </h1>
      <p className="mt-4 text-mindora-muted leading-relaxed max-w-2xl">
        Short, practical exercises for the moments that matter — a hard conversation with a parent,
        a friend who's pulling away, the silence inside yourself.
      </p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="empathy-grid">
        {exercises.map((ex, i) => (
          <Link
            key={ex.id}
            to={`/empathy/${ex.id}`}
            data-testid={`empathy-card-${ex.id}`}
            className="group rounded-3xl border border-mindora-line bg-mindora-panel p-7 shadow-clay hover:shadow-clayHover hover:-translate-y-1 transition-all duration-500"
          >
            <div className="text-xs uppercase tracking-[0.2em] text-mindora-red">{ex.category}</div>
            <h3 className="font-serif text-2xl text-mindora-ink leading-snug mt-3 group-hover:text-mindora-red transition-colors">
              {ex.title}
            </h3>
            <p className="mt-3 text-sm text-mindora-muted leading-relaxed">{ex.summary}</p>
            <div className="mt-5 flex items-center justify-between text-xs text-mindora-muted">
              <span className="flex items-center gap-1.5"><Clock size={12} /> {ex.duration_min} min</span>
              <span className="text-mindora-red opacity-0 group-hover:opacity-100 transition-opacity">try this →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
